
import axios from 'axios';

//const LOCALHOST = 'http://localhost:8080'
const LOCALHOST = 'https://www.sirifarms.com'
export const API_BASE_URL = LOCALHOST

const api = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Use request interceptor to dynamically get JWT for each request
// This ensures the token is always fresh from localStorage, not stale from module load
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.defaults.headers.post['Content-Type'] = 'application/json';

export default api;
